import { env } from 'app/Env/env';
import axios from 'axios';
import { isInIframe } from 'utils/isInIframe';

const defaultInstance = axios.create();

const HTTP_OPTIONS = {
	withCredentials: true
};

const getSSOAppBaseUrl = () => env.baseUrl!;

const initDefaultInstance = () => {
	defaultInstance.defaults.baseURL = getSSOAppBaseUrl();
	defaultInstance.defaults.headers.common['x-sso-suite-mode'] = APP_MODE;
	defaultInstance.defaults.headers.common['x-sso-suite-framed'] =
		String(isInIframe());
};

export const staticBaseURL = () => {
	const path = env.baseStaticUrl || '';
	return path.startsWith('/') ? window.location.origin + path : path;
};

export const initApp = () => {
	initDefaultInstance();
};

export { HTTP_OPTIONS, defaultInstance };
